<template>
    <div class="callback-container">
        <div class="top-tips">
            <p>
                （1）根据实际的使用需要，设置相应的回调地址，只支持https（例：https://xx.zonelink.com 或 https://xx.zonelink.com/xx），不支持http、IP地址、端口号及短链域名。
            </p>
            <p>
                （2）填写的域名须通过ICP备案的验证。
            </p>
            <p>
                （3）若不使用回调删除对应的回调地址即可。
            </p>
            <p>
                （4）需要打印结果回调时调用打印接口时需附加设置好的回调地址参数backurl，详见 <span class="link" @click="gotoDoc">开发文档</span> 。
            </p>
            <p>
                （5）<font color="blue">【重要】回调地址必须提供一个</font>
                <font color="red">GET</font>
                <font color="blue">方法，返回</font>
                <font color="red">ZONELINK-SUCCESS</font>
                <font color="blue">用于云服务器检测接口是否可用</font>
            </p>
        </div>
        <div class="callback-form">
            <el-form ref="callbackForm" :model="form" :rules="rule" label-width="100px">
                <el-form-item label="回调地址：" prop="backUrl" required>
                    <el-input v-model="form.backUrl" placeholder="请输入打印结果回调地址（只支持https）"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="isLoading" @click="saveCallbackUrl">保存地址</el-button>
                    <el-button type="warning" @click="reloadCallbackUrl">重新加载</el-button>
                    <el-button type="danger" @click="deleteCallbackUrl">删除地址</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            loginInfo: null,
            isLoading: false,
            headers: null,
            form: {
                backUrl: null
            },
            rule: {
                backUrl: [{ required: true, message: '请输入打印结果回调地址', trigger: 'blur' },
                { pattern: /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, message: '请检查回调地址格式是否正确', trigger: 'blur' }]
            }
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        this.loginInfo = JSON.parse(loginInfoStr);
        let developer = this.loginInfo.developer;
        this.form.backUrl = developer.backUrl;
        let token = this.loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
    },
    methods: {
        gotoDoc() {
            this.$emit("jump", "/open");
        },
        reloadCallbackUrl() {
            this.form.backUrl = this.loginInfo.developer.backUrl;
        },
        saveCallbackUrl() {
            this.$refs["callbackForm"].validate((valid) => {
                if (valid) {
                    this.isLoading = true;
                    // 测试填写的地址是否可用
                    this.axios.get(this.form.backUrl).then(testRes => {
                        if (testRes.data != "ZONELINK-SUCCESS") {
                            let errMsg = "亲，GET 方法返回值不正确哦~";
                            this.$message.error(errMsg);
                            this.$showErrorMsg(errMsg);
                            this.isLoading = false;
                        } else {
                            this.$confirm('亲，是否确认保存当前回调地址？', '确认信息').then(() => {
                                this.axios.put(this.$apiUrl + "/developbackend/updateBackurl", this.form, {
                                    headers: this.headers
                                }).then(res => {
                                    if (res.data.code == 200) {
                                        this.$message({
                                            message: '亲，恭喜您回调地址已成功更新啦~',
                                            type: 'success'
                                        });
                                        this.$showSuccessMsg("亲，恭喜您回调地址已成功更新啦~");

                                        // 更新sessionStorage
                                        this.loginInfo.developer.backUrl = this.form.backUrl;
                                        sessionStorage.setItem("loginInfo", JSON.stringify(this.loginInfo));
                                    } else {
                                        this.$message.error(res.data.msg);
                                        this.$showErrorMsg(res.data.msg);
                                    }
                                    this.isLoading = false;
                                }).catch((e) => {
                                    this.$message.error(e.toString());
                                    this.$showErrorMsg(e.toString());
                                    this.isLoading = false;
                                });
                            }).catch(() => {
                                this.isLoading = false;
                            });
                        }
                    }).catch(testErr => {
                        this.isLoading = false;
                        this.$message.error(testErr.toString());
                        this.$showErrorMsg(testErr.toString());
                    });
                }
            });
        },
        deleteCallbackUrl() {
            this.$confirm('亲，是否确认删除当前回调地址？', '确认信息').then(() => {
                this.axios.delete(this.$apiUrl + "/developbackend/deleteBackurl/" + this.loginInfo.developer.id, {
                    headers: this.headers
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '亲，恭喜您回调地址已成功删除啦~',
                            type: 'success'
                        });
                        this.$showSuccessMsg("亲，恭喜您回调地址已成功删除啦~");

                        // 更新sessionStorage
                        this.loginInfo.developer.backUrl = null;
                        this.$refs.callbackForm.resetFields();
                        this.form.backUrl = "";
                        sessionStorage.setItem("loginInfo", JSON.stringify(this.loginInfo));
                    } else {
                        this.$message.error(res.data.msg);
                        this.$showErrorMsg(res.data.msg);
                    }
                }).catch((e) => {
                    this.$message.error(e.toString());
                    this.$showErrorMsg(e.toString());
                });
            }).catch(() => { });
        }
    }
}
</script>


<style scoped>
.callback-container {
    margin-right: 15px;
}

.callback-form {
    margin-top: 30px;
}

.top-tips {
    padding: 15px;
    background-color: #fff8eb;
    border: solid 1px #ffd6b1;
    border-left: 5px solid #ff7800;
    margin-bottom: 15px;
}

.link {
    color: blue;
    cursor: pointer;
    text-decoration: underline;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// callback.vue?0045c6b6